import axios from "axios";
import { handleError } from "./errorHandler.ts";

const api = axios.create({
  // production endpoint
  // baseURL: "https://www.api.etpm.chiksoft.com/api/",
  //development endpoint
  // baseURL: "https://api.test.chiksoft.com/api/", // last update 2026-29-09
  baseURL: "https://api.etpm.chiksoft.com/api/", // first use 2026-29-09
  timeout: 240000,
});

// Interceptor to add Authorization header automatically
api.interceptors.request.use((config) => {
  // const token = localStorage.getItem("token");
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor for handling errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleError(error);
    return Promise.reject(error);
  },
);

export default api;
